// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-f7e4043e]:after{content:normal}.rating[data-v-f7e4043e]{display:flex;flex-flow:row nowrap;justify-content:flex-start}.rating__review-rating[data-v-f7e4043e]{margin:5px 0}.rating__reviews[data-v-f7e4043e]{margin-bottom:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
